<div class="card">
    <a *ngIf="linkType != linkTypes.None" [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType == linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="['/communities/', dso.id]" class="card-img-top">
        <ds-themed-thumbnail [thumbnail]="(dso.logo | async)?.payload" [limitWidth]="false">
        </ds-themed-thumbnail>
    </a>
    <span *ngIf="linkType == linkTypes.None" class="card-img-top">
    <ds-themed-thumbnail [thumbnail]="(dso.logo | async)?.payload" [limitWidth]="false">
    </ds-themed-thumbnail>
  </span>
    <div class="card-body">
        <ds-themed-badges *ngIf="showLabel" [object]="dso"></ds-themed-badges>
        <h4 class="card-title">{{dso.name}}</h4>
        <p *ngIf="dso.shortDescription" class="card-text">{{dso.shortDescription}}</p>
        <div *ngIf="linkType != linkTypes.None" class="text-center">
            <a [target]="(linkType == linkTypes.ExternalLink) ? '_blank' : '_self'" [attr.rel]="(linkType == linkTypes.ExternalLink) ? 'noopener noreferrer' : null" [routerLink]="['/communities/', dso.id]" class="lead btn btn-primary viewButton">View</a>
        </div>
    </div>
    <ng-content></ng-content>
</div>
